var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "blum-report-editor",
      class: { "section-focused": _vm.isFocused },
      attrs: { id: "section-editor-" + _vm.section.id }
    },
    [
      _c(
        "div",
        {
          staticClass: "report-editor-close",
          class: { "section-focused": _vm.isFocused }
        },
        [
          _c(
            "div",
            {
              staticClass: "w-6 h-6 cursor-pointer",
              on: { click: _vm.onClose }
            },
            [
              _c("BlIcon", {
                staticClass: "w-6 h-6",
                attrs: { icon: "close", clickable: "" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c("vue-editor", {
        attrs: {
          "editor-toolbar": _vm.customToolbar,
          placeholder: _vm.mode === "edit" ? "Type your text here" : ""
        },
        model: {
          value: _vm.htmlInput,
          callback: function($$v) {
            _vm.htmlInput = $$v
          },
          expression: "htmlInput"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "report-editor-delete",
          class: { "section-focused": _vm.isFocused }
        },
        [
          _c("BlInputButton", {
            attrs: {
              type: "outlined-error",
              dense: "",
              label: "Delete",
              loading: _vm.removeLoading
            },
            on: { clicked: _vm.onRemoveSection }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01b758cc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01b758cc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/editor/TextEditor.vue
// module id = null
// module chunks = 